// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PorticoPortalModel {
    static getAttributeTypeMap() {
        return PorticoPortalModel.attributeTypeMap;
    }
}
PorticoPortalModel.discriminator = undefined;
PorticoPortalModel.additionalProperties = false;
PorticoPortalModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    },
    {
        "name": "portalGroupId",
        "baseName": "portalGroupId",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "url",
        "baseName": "url",
        "type": "string"
    },
    {
        "name": "beginOn",
        "baseName": "beginOn",
        "type": "Date"
    },
    {
        "name": "endOn",
        "baseName": "endOn",
        "type": "Date"
    },
    {
        "name": "settings",
        "baseName": "settings",
        "type": "string"
    },
    {
        "name": "coreVersion",
        "baseName": "coreVersion",
        "type": "string"
    },
    {
        "name": "createdBy",
        "baseName": "createdBy",
        "type": "number"
    },
    {
        "name": "createdOn",
        "baseName": "createdOn",
        "type": "Date"
    },
    {
        "name": "portalGroup",
        "baseName": "portalGroup",
        "type": "PorticoPortalGroupModel"
    },
    {
        "name": "portalChildren",
        "baseName": "portalChildren",
        "type": ""
    },
    {
        "name": "portalDataGroups",
        "baseName": "portalDataGroups",
        "type": ""
    },
];
//# sourceMappingURL=porticoPortalModel.js.map